import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  dropZone: {
    fontFamily: 'roboto',
    textAlign: 'center',
    height: '125px',
    color: theme.palette.grey[400],
    margin: '15px 0px',
    borderRadius: '10px',
    padding: '50px',
    cursor: 'pointer',
    border: '2px solid',
    borderColor:  theme.palette.grey[400],
    background: theme.palette.grey[200],

    '&[aria-disabled]': {
      cursor: 'default',
    },
  },

  dropZoneActive: {
    borderColor:  theme.palette.primary.main,
  },
});

class UploadDropZoneComponent extends React.Component {
  constructor(props) {
    super(props);

    this.onDrop = this.onDrop.bind(this);
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);

    this.state = {
      active: false,
    };
  }

  onDrop(files) {
    this.setState({
      active: true,
    });

    this.props.onFileChange(files, () => {
      this.setState({
        active: false,
      });
    });
  }

  onDragEnter() {
    this.setState({ active: true });
  }

  onDragLeave() {
    this.setState({ active: false });
  }

  render() {
    const {
      text,
      isProcessing,
      width,
      classes,
    } = this.props;

    return (

      <Dropzone
        onDrop={this.onDrop}
        onDragEnter={this.onDragEnter}
        onDragLeave={this.onDragLeave}
        disabled={isProcessing}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <div {...getRootProps()}
              style={{ width: width === 'full' ? '100%' : `${width}px` }}
              className={[classes.dropZone, this.state.active ? classes.dropZoneActive : null].join(' ')}>
              <input {...getInputProps()} />
              <Typography>
                {text}
              </Typography>
            </div>
          </section>
        )}
      </Dropzone>
    );
  }
}

UploadDropZoneComponent.propTypes = {
  text: PropTypes.string.isRequired,
  width: PropTypes.string,
  onFileChange: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool,
  /* eslint-disable  */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

UploadDropZoneComponent.defaultProps = {
  isProcessing: false,
  width: '525',
};

export default withStyles(styles)(UploadDropZoneComponent);
